const netsuiteAccount = (key, label, acctNumber = '', acctName = '') => ({
  key, label, acctNumber, acctName,
});

export const NETSUITE_TABS = [
  {
    key: 'subsidiary',
    title: 'Subsidiary',
  },
  {
    key: 'bill_operadores',
    title: 'Bill Operadores',
    accounts: [
      netsuiteAccount('accounts_payable_operadores', 'Cuentas por Pagar Operadores', '2003', 'Cuentas por Pagar Operadores'),
      netsuiteAccount('comision_recorrido_b2c', 'Comisión Recorrido B2C', '4007', 'Comisión Recorrido B2C'),
      netsuiteAccount('gasto_operador', 'Gasto Operador', '6040', 'Gasto Operador'),
    ],
  },
  {
    key: 'credit_bill_operadores',
    title: 'Credit Bill Operadores',
    accounts: [
      netsuiteAccount('accounts_payable_operadores', 'Cuentas por Pagar Operadores', '2003', 'Cuentas por Pagar Operadores'),
      netsuiteAccount('gasto_operador', 'Gasto Operador', '6040', 'Gasto Operador'),
    ],
  },
  {
    key: 'invoice',
    title: 'Invoice',
    accounts: [
      netsuiteAccount('cuentas_por_cobrar_medios_pago', 'Cuentas por Cobrar Medios de Pago', '11002', 'Cuentas por Cobrar Medios de Pago'),
      netsuiteAccount('ingreso_medio_pago', 'Ingreso Medio de Pago', '6039', 'Ingreso Medio de Pago'),
      netsuiteAccount('ingreso_axa', 'Ingreso Axa', '4001', 'Ingreso Axa'),
      netsuiteAccount('axa_por_pagar', 'Axa por Pagar', '1109', 'Axa por Pagar'),
      netsuiteAccount('cuota_transporte_b2c', 'Cuota Transporte B2C', '40071', 'Cuota Transporte B2C'),
      netsuiteAccount('cuota_transporte_paypal', 'Cuota Transporte PayPal', '40072', 'Cuota Transporte PayPal'),
      netsuiteAccount('cuota_transporte_b2b', 'Cuota Transporte B2B', '40073', 'Cuota Transporte B2B'),
      netsuiteAccount('cuota_transporte_otro', 'Cuota Transporte otro motivo', '40077', 'Cuota Transporte otro motivo'),
      netsuiteAccount('rr_fee', 'RR Fee', '4013', 'RR Fee'),
      netsuiteAccount('iva_rr_fee', 'IVA RR Fee', '21813', 'IVA RR Fee'),
    ],
  },
  {
    key: 'credit_memo_medio_pago',
    title: 'Credit Memo - Medio de Pago',
    accounts: [
      netsuiteAccount('cuentas_por_cobrar_medios_pago', 'Cuentas por Cobrar Medios de Pago', '11002', 'Cuentas por Cobrar Medios de Pago'),
      netsuiteAccount('ingreso_medio_pago', 'Ingreso Medio de Pago', '6039', 'Ingreso Medio de Pago'),
      netsuiteAccount('cuota_transporte_b2c', 'Cuota Transporte B2C', '40071', 'Cuota Transporte B2C'),
      netsuiteAccount('cuota_transporte_paypal', 'Cuota Transporte PayPal', '40072', 'Cuota Transporte PayPal'),
      netsuiteAccount('cuota_transporte_b2b', 'Cuota Transporte B2B', '40073', 'Cuota Transporte B2B'),
      netsuiteAccount('cuota_transporte_otro', 'Cuota Transporte otro motivo', '40077', 'Cuota Transporte otro motivo'),
    ],
  },
  {
    key: 'bill_axa',
    title: 'Bill AXA',
    accounts: [
      netsuiteAccount('axa_por_pagar', 'Axa por Pagar', '1109', 'Axa por Pagar'),
    ],
  },
  {
    key: 'credit_memo_cupones',
    title: 'Credit Memo - Cupones',
    accounts: [
      netsuiteAccount('pasivo_cupones', 'Pasivo Cupones'),
      netsuiteAccount('ingreso_medio_pago', 'Ingreso Medio de Pago', '6039', 'Ingreso Medio de Pago'),
      netsuiteAccount('cuota_transporte_b2c', 'Cuota Transporte B2C', '40071', 'Cuota Transporte B2C'),
      netsuiteAccount('cuota_transporte_paypal', 'Cuota Transporte PayPal', '40072', 'Cuota Transporte PayPal'),
      netsuiteAccount('cuota_transporte_b2b', 'Cuota Transporte B2B', '40073', 'Cuota Transporte B2B'),
      netsuiteAccount('cuota_transporte_otro', 'Cuota Transporte otro motivo', '40077', 'Cuota Transporte otro motivo'),
    ],
  },
];

export default NETSUITE_TABS;
